export default {
	sec_01: {
		title: {
			one: 'You can get additional ',
			two: 'rewards',
			three: 'by using JP WORLD Pay',
		},
		desc: {
			one: 'Save money by transactions,',
			two: 'cashback offers and promotional code',
			three: 'and get rewards from the best stores and your favorite brands.',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_09: {
		title: {
			one: 'Trade in cryptocurrency ',
			two: 'that suits me',
		},
		one: {
			desc: {
				one: 'We will showcase deals, products and',
				two: 'stores you think you will like based on where you shop and buy,',
				three:
					'and we promise to continue to increase and update your favorite stores.',
			},
		},
	},
	sec_03: {
		one: {
			title: {
				one: 'Maximize your rewards',
				two: 'Maximize rewards',
			},
			desc: {
				one: 'Combining transactions, cashback suggestions and',
				two: 'promotional code can save you more money.',
				three: 'We will help you find and apply promotion codes when you pay.',
				four: 'Does JP WORLD Pay card offer a reward?',
				five: 'Check out for your purchase and use it to get a reward.',
			},
			btn: 'Start shopping',
		},
		two: {
			title: {
				one: 'Secure checkout',
			},
			desc: {
				one: 'Utilize transaction and cashback offers from millions of global retailers',
				two: 'when making payments securely with JP WORLD Pay.',
				three: 'Your information is encrypted and',
				four: 'will not be sold or shared without your permission.',
			},
			btn: 'Learn how to protect yourself',
		},
	},
	common: {
		coming_soon: 'Coming soon.',
	},
};
